import AxiosClient from "../../../services/axios.services";

class UnlinkTemplatesServices {
  getUnlinkTemplates = (params) =>
    AxiosClient.get("/api/app/sanciones_categoria_desvinculacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveUnlinkTemplates = (data) =>
    AxiosClient.post("/api/app/sanciones_categoria_desvinculacion/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editUnlinkTemplates = (id, data) =>
    AxiosClient.put(`/api/app/sanciones_categoria_desvinculacion/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteUnlinkTemplates = (id) =>
    AxiosClient.delete(`/api/app/sanciones_categoria_desvinculacion/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new UnlinkTemplatesServices();
